<bl-modal-content
  #content
  [title]="'初期表示設定'"
>
  <div body>
    <div class="contents">


      <div class="setting-item setting-item--explanation">
        日付範囲の初期値を設定してください。
      </div>
      <div class="setting-item">
        <div class="setting-item__label">
          <label>日付範囲</label>
        </div>
        <div class="setting-item__input">
          <!-- 適用開始期間基準区分 -->
          <bl-select
            class="period_criteria_div_item"
            [(value)]="applyStartPeriodCriteriaDiv"
            [items]="applyPeriodCriteriaDivItems"
          ></bl-select>
          <bl-number-input
            [(value)]="applyStartNum"
            [option]="{ minus: false, min: 0, max: 99 }"
            [disabled]="isApplyStartPeriodToday"
          ></bl-number-input>
          <!-- 月週日区分（開始用） -->
          <bl-select
            class="month_week_day_div_item"
            [(value)]="monthWeekDayDivStart"
            [items]="monthWeekDayDivItems"
            [disabled]="isApplyStartPeriodToday"
          ></bl-select>
          <span class="from_to">～</span>
          <!-- 適用終了期間基準区分 -->
          <bl-select
            class="period_criteria_div_item"
            [(value)]="applyEndPeriodCriteriaDiv"
            [items]="applyPeriodCriteriaDivItems"
          ></bl-select>
          <bl-number-input
            [(value)]="applyEndNum"
            [option]="{ minus: false, min: 0, max: 99 }"
            [disabled]="isApplyEndPeriodToday"
          ></bl-number-input>
          <!-- 月週日区分（終了用） -->
          <bl-select
            class="month_week_day_div_item"
            [(value)]="monthWeekDayDivEnd"
            [items]="monthWeekDayDivItems"
            [disabled]="isApplyEndPeriodToday"
          ></bl-select>
        </div>
      </div>

      <div class="setting-item setting-item--explanation">
        日付種別の初期値を設定してください。
      </div>
      <div class="setting-item">
        <div class="setting-item__label">
          <label>日付種別</label>
        </div>
        <div class="setting-item__input">
          <bl-select
            [(value)]="_screenActionSetting && _screenActionSetting.searchTargetDateType"
            [items]="SearchTargetDateTypeArray"
          ></bl-select>
        </div>
      </div>

      <div class="setting-item setting-item--explanation">
        受付状況の初期値を設定してください。
      </div>
      <div class="setting-item">
        <div class="setting-item__label">
          <label>受付状況</label>
        </div>
        <div class="setting-item__input">
          <bl-multi-select
            [values]="_screenActionSetting && _screenActionSetting.bizNegoStatusList || []"
            [items]="FilteredBizNegoStatusArray"
            [option]="{labelProperty: 'text', valueProperty: 'value'}"
            [enableAllCheckbox]="true"
            (changeItemsEvent)="onChangeBizNegoStatusList($event)"
          ></bl-multi-select>
        </div>
      </div>
      <div class="setting-item setting-item--notice">
        ※初期表示設定はご利用のアカウントごとに保存されます。
      </div>
    </div>
  </div>
</bl-modal-content>



// WEBPACK FOOTER //
// ./src/app/page/recept-list-page/modal/recept-search-screen-action-setting-modal/recept-search-screen-action-setting-modal.component.html